import { useMemo } from "react";

const useMetabaseUrl = ({
  url,
  parameters = {},
  hideList = [],
  hideHeader = true,
}) => {
  return useMemo(() => {
    if (!url) {
      return "";
    }
    let parsedUrl;

    try {
      parsedUrl = URL.parse(url);
    } catch (e) {
      console.error(e);
      return "";
    }
    const searchParams = new URLSearchParams();
    if (parameters) {
      Object.entries(parameters).forEach(([key, value]) => {
        if (value != null && value !== "") {
          searchParams.set(key, String(value));
        }
      });
      parsedUrl.search = searchParams.toString();
    }

    if (hideList && hideList.length > 0) {
      parsedUrl.hash = `hide_parameters=${encodeURIComponent(hideList.join(","))}`;
    }
    return parsedUrl.toString();
  }, [url, JSON.stringify(parameters), hideList?.join(",")]);
};

export default useMetabaseUrl;
